export default __webpack_public_path__ + "static/ti_Monster_Origionally-1abf56ebcf3f6fa86baddac8b45040aa.png";